<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-autocomplete
          label="Origem"
          hide-details

          multiple
          clearable
          small-chips
          deletable-chips

          :items="filterOptions.origin"
          :value="filters.origin"
          @change="(newValue) => updateFilters({ origin: newValue })"
        />
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          label="Descrição"
          hide-details

          multiple
          clearable
          small-chips
          deletable-chips

          :items="filterOptions.description"
          :value="filters.description"
          @change="(newValue) => updateFilters({ description: newValue })"
        />
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          label="Data da operação"
          hide-details

          multiple
          clearable
          small-chips
          deletable-chips

          :items="filterOptions.refDate"
          :value="filters.refDate"
          @change="(newValue) => updateFilters({ refDate: newValue })"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CashSettlementsStatementsFilters',

  props: {
    filters: {
      type: Object,
      required: true,
    },

    filterOptions: {
      type: Object,
      required: true,
    },
  },

  watch: {
    filterOptions: {
      deep: true,
      immediate: true,
      handler(newOptions) {
        const validFilters = {};

        Object.entries(newOptions).forEach(([key, options]) => {
          if (!Array.isArray(this.filters[key])) return;

          validFilters[key] = this.filters[key].filter((val) => options.includes(val));
        });

        this.updateFilters(validFilters);
      },
    },
  },

  methods: {
    updateFilters(newValues) {
      this.$emit('update:filters', { ...this.filters, ...newValues });
    },
  },
};
</script>
